import React from "react";

export function Strikethrough(props: { children: React.ReactNode }) {
	return <span style={{ textDecoration: "line-through" }}>{props.children}</span>;
}
